import cn from 'classnames';
import React from 'react';
import sharedConfig from "@dataroom/config";
import DataroomListItem from '../../../domain/DataroomListItem';
import DateCell from '@framework/ui/Molecules/Tables/CellCallbacks/DateCell';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import styles from '../datarooms.module.scss';
import stylesForSet from '../../Set/set.module.scss';
import { IDataroomListItem } from '../../../domain/vo/DataroomListItem';

interface IProps {
  cellProps: {
    row: IDataroomListItem,
    cellTitle?: React.ReactNode,
    countryId?: string | null,
  },
  children: React.ReactNode,
  isDisabled?: boolean,
}

const LastActivityCell = ({
  cellProps,
  children,
  isDisabled,
}: IProps) => {
  const { tenant } = useDataroomTenantContext();
  const isSet = tenant === sharedConfig.investorset.code || tenant === sharedConfig.verisend.code
    || tenant === sharedConfig.researchroom.code;
  const dataroom = cellProps.row;
  const {
    timezone: {
      timeZone,
      abbr,
    },
    lastActivity,
  } = dataroom;
  const isDataroomDisabled = DataroomListItem.isDataroomDisabled(dataroom);
  const tableStyles = isSet ? stylesForSet : styles;

  return (
    <div className={ styles.dataroomExpDateWrp }>
      <div
        className={
          cn(
            tableStyles.dataroomExpDate, {
              [tableStyles.deactivatedDataroom]: isDataroomDisabled,
              [styles.columnDisable]: isDisabled,
            },
          )
        }
      >
        <span className={ tableStyles.mobileColName }>{ cellProps.cellTitle }</span>
        <DateCell
          date={ lastActivity }
          timeZone={ timeZone }
          timeZoneAbbr={ abbr }
          isUtc
        />
      </div>
      { children || '' }
    </div>
  );
};

export default LastActivityCell;
